export default "__VITE_ASSET__DHfKKzTU__"